import axios, { Method } from 'axios';

interface IAdd {
  items: IItem[]
}

interface IUpdate {
  updates: IUpdateObject
}

interface IUpdateObject {
  [key: number]: number
}

interface IItem {
  quantity: number,
  id: number,
  properties?: JSON
}

interface IEndpoints {
  add: IEndpoint,
  get: IEndpoint,
  update: IEndpoint,
  change: IEndpoint,
  clear: IEndpoint
}

interface IEndpoint {
  url: string,
  method: Method
}

class Cart {

  private endpoints:IEndpoints;

  constructor() {
    this.endpoints = {
      add: {
        url: '/cart/add.js', 
        method: 'post' 
      },
      get: {
        url: '/cart.js', 
        method: 'get' 
      },
      update: {
        url: '/cart/update.js', 
        method: 'post' 
      },
      change: {
        url: '/cart/change.js', 
        method: 'post' 
      },
      clear: {
        url: '/cart/clear.js', 
        method: 'post' 
      }
    }
  }

  add(data:IAdd) {
    return new Promise((resolve, reject) => {
      this.request('add', resolve, reject, data);
    });
  }

  get() {
    return new Promise((resolve, reject) => {
      this.request('get', resolve, reject);
    });
  }

  update(data:IUpdate) {
    return new Promise((resolve, reject) => {
      this.request('update', resolve, reject, data);
    });
  }

  change(data:IItem) {
    return new Promise((resolve, reject) => {
      this.request('update', resolve, reject, data);
    });
  }

  clear() {
    return new Promise((resolve, reject) => {
      this.request('clear', resolve, reject);
    });
  }

  async request(key:keyof IEndpoints, resolve:any, reject:any, data?:IAdd|IUpdate|IItem) {
    let response;
    const url = window.location.origin + this.endpoints[key].url;
    const method:Method = this.endpoints[key].method;

    try {
      response = await axios({
        method,
        url,
        data,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    }
    catch(error) {
      reject(error);
    }

    resolve(response);
  }
}

export default new Cart();